import React, { useState, useEffect } from 'react';
import { Text, Center, Spinner } from '@chakra-ui/react';
import CompaniesApi from '../../../../../../api/companies';
import OperationLocationAPI from '../../../../../../api/operationlocation';
import Form from './storeDetails';
import StoresApi from 'api/stores';
import { isValidUUID } from 'utils/fetchUtils';
import PageError from 'components/nopermission/PageError';

const Branch = (props) => {
  const [storeData, setStoreData] = useState();
  const [operationLocationsList, setOperationLocationsList] = useState([]);
  const [companiesList, setCompaniesList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [storeDataFetched, setStoreDataFetched] = useState(false);
  const [companiesFetched, setcompaniesFetched] = useState(false);
  const [operationLocationsFetched, setOperationLocationsFetched] =
    useState(false);
  const [fetchStoreDataError, setFetchStoreDataError] = useState(false);

  const storeId = IdFromUrl(window.location.href);
  function IdFromUrl(url) {
    // Split the URL by slashes
    const parts = url.split('/');

    // The last part of the URL is the ID
    const id = parts[parts.length - 1];

    return id;
  }

  const FetchStoreData = async () => {
    if (!isValidUUID(storeId)) {
      setFetchStoreDataError(true);
      return;
    }
    try {
      setLoading(true);
      let response = await StoresApi.List({
        storeId,
      });
      response = response.data;
      setStoreDataFetched(true);
      companiesFetched &&
        operationLocationsFetched &&
        storeDataFetched &&
        setLoading(false);
      if (response.status_code === 200) {
        setFetchStoreDataError(false);
        setStoreData(response?.data);
      } else {
        setFetchStoreDataError(true);
        setStoreData(null);
      }
    } catch (err) {
      setFetchStoreDataError(true);
      console.log(err);
    }
  };
  useEffect(() => {
    FetchStoreData();
  }, []);

  const FetchCompaniesList = async () => {
    try {
      setLoading(true);
      let response = await CompaniesApi.List({
        sort: 'name:asc',
      });
      response = response.data;
      setcompaniesFetched(true);
      companiesFetched &&
        operationLocationsFetched &&
        storeDataFetched &&
        setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        // console.log(response.data);
        setCompaniesList(response?.data?.list);
      } else {
        setCompaniesList(null);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    FetchCompaniesList();
  }, []);

  const fetchOperationLocationsList = async () => {
    try {
      setLoading(true);
      let response = await OperationLocationAPI.List({
        sort: 'name:asc',
      });
      response = response.data;
      setOperationLocationsFetched(true);
      companiesFetched &&
        operationLocationsFetched &&
        storeDataFetched &&
        setLoading(false);
      if (response.status_code == 200 && response?.data?.list?.length > 0) {
        setOperationLocationsList(response?.data?.list);
      } else {
        setOperationLocationsList(null);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchOperationLocationsList();
  }, []);

  return (
    <>
      {fetchStoreDataError ? (
        <PageError />
      ) : loading && companiesList && operationLocationsList && storeData ? (
        <Form
          operationLocationsList={operationLocationsList}
          companiesList={companiesList}
          storeData={storeData}
          storeId={storeId}
        />
      ) : (
        <>
          <Center
            mt={60}
            width='100%'
            // bgColor='red'
          >
            <Spinner size='xl' />
          </Center>
          <Text
            fontSize='2xl'
            fontWeight='700'
            mt={10}
            p={4}>
            Loading Branch Data ....
          </Text>
        </>
      )}
    </>
  );
};

export default Branch;
